import React from 'react'
import DiscountTypeInput from './DiscountTypeInput'
import CurrencyInput from '@cbgms/components/form/CurrencyInput'
import { connect } from 'react-redux'
import { IRootReducerState } from 'state/rootReducer'
import { Validator, formValueSelector } from 'redux-form'
import Input, { ReduxInputProps, StrippedInputProps } from '@cbgms/components/form/Input'
import { LabelProps } from 'semantic-ui-react'
import { SemanticShorthandItem } from 'semantic-ui-react/dist/commonjs/generic'

interface IOwnProps extends StrippedInputProps {
  formName: string
  discountTypeFieldName: string
  label?: SemanticShorthandItem<LabelProps>
  fluid?: boolean
  validate?: Validator | Validator[]
}

interface IStateToProps {
  discountIsAmount: boolean
}

export interface DiscountInputProps extends IOwnProps, IStateToProps {}

const mapStateToProps = (state: IRootReducerState, props: IOwnProps): IStateToProps => {
  const { formName, discountTypeFieldName } = props
  const selector = formValueSelector(formName)

  return {
    discountIsAmount: selector(state, discountTypeFieldName)
  }
}

const enhance = connect<IStateToProps, {}, IOwnProps, IRootReducerState>(mapStateToProps)

export class DiscountInput extends React.Component<DiscountInputProps> {
  render() {
    const { name, discountIsAmount, discountTypeFieldName, fluid, validate, label } = this.props

    const Component: React.FC<ReduxInputProps> = discountIsAmount ? CurrencyInput : Input

    return (
      <Component fluid={fluid} validate={validate} label={label} name={name} action={<DiscountTypeInput name={discountTypeFieldName} />} />
    )
  }
}

export default enhance(DiscountInput)
